module.exports = __webpack_public_path__ + "img/dylan1.6983fe84.jpg";